/*
  Requests
*/

/*export const defaultUrl = "http://ec2-3-76-10-149.eu-central-1.compute.amazonaws.com";*/
export const defaultUrl = "https://prihlasovani.novyp.org"

const sendReq = (
  opts: Object,
  url: string,
  endpoint: string,
  errMsgSetter?: Function
) => {
  return fetch(url + endpoint, opts)
    .then(async (res) => {
      let temp = await res.json();
      temp.status = res.status;
      return temp;
    })
    .catch((err) => {
      console.log("Hey there stranger! Dont mind these, some of them are even expected to happen :3")
      console.log(err);
      if (errMsgSetter) {
        errMsgSetter("Něco se pokazilo");
      }
    });
};

export const sendGetReq = async (
  endpoint: string,
  errMsgSetter?: Function,
  url: string = defaultUrl
) => {
  const opts = {
    method: "GET",
  };
  return await sendReq(opts, url, endpoint, errMsgSetter);
};

export const sendPostReq = async (
  endpoint: string,
  body: StrIndexedObj,
  errMsgSetter?: Function,
  url: string = defaultUrl,
) => {
  let postData = new FormData();
  Object.keys(body).forEach((key) => {
    postData.append(key, body[key]);
  });

  const opts = {
    method: "POST",
    body: postData,
  };
  return await sendReq(opts, url, endpoint, errMsgSetter);
};

/*
  Miscelaneous
*/
export const onChange = (data: Object, setData: Function, e: any) => {
  let temp = data;
  let id: keyof typeof temp = e.target.id;
  temp[id] = e.target.value;
  setData(temp);
};

export const compressObjects = (data: Object[], key: string) => {
  return data.map((o: { [key: string]: any }) => {
    return o[key];
  });
};

export const createArr = (len: number, defaultVal: any = null) => {
  return Array.apply(defaultVal, Array(len)).map(function () {
    return defaultVal;
  });
};

export const days = ["Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota", "Neděle"]
export const day = (dayI: number) => {
  return days[dayI]
}

/*
  General types
*/
export type StrIndexedObj = { [key: string]: any };

/* 
  Types
*/
export interface User {
  id: number;
  name: string;
  surname: string;
  class: string;
  studentYear: number;
  email: string;
  role: "teacher" | "student";
  school: number; // ???
  lastLogin: string | Date;
  token: string;
}

export interface Course {
  id: number;
  name: string;
  description: string;
  school: number; // ???
  minAge: number;
  maxAge: number;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  capacity: number;
  teacher: number; // ???
  image: string;
  currentUserSignedIn: boolean;
  signedInStudents?: User[];
  totalSignedInStudents: number;
  pdf?: string;
}

/* Data */
export const grades: StrIndexedObj = {
  "1": "1. třída ZŠ",
  "2": "2. třída ZŠ",
  "3": "3. třída ZŠ",
  "4": "4. třída ZŠ",
  "5": "5. třída ZŠ",
  "6": "6. třída ZŠ/prima 8G",
  "7": "7. třída ZŠ/sekunda 8G",
  "8": "8. třída ZŠ/tercie 8G",
  "9": "9. třída ZŠ/kvarta 8G",
  "10": "prvák 4G/kvinta 8G",
  "11": "druhák 4G/sexta 8G",
  "12": "třeťák 4G/septima 8G",
  "13": "čtvrťák 4G/oktáva 8G",
}
